import styled, { css } from 'styled-components';
import { OVERLAY_WIDTH_EVOLUTION } from '@/app/components/search/components/EvolutionCard/constants.ts';
import { imageRoundingStyles } from '@/app/components/search/components/EvolutionCard/Gallery/styled.ts';
import { loadingBackground, userSelectNone } from '../../../../styles/mixins';
import { imageWidthStyle } from '../../utils/styled';

const mobileStyles = css`
  height: 160px;
  min-height: 160px;
`;

const mobileNonOverlayStyles = css`
  width: 100%;
  aspect-ratio: 2 / 1;
  height: auto;
`;

const desktopStyles = css`
  margin-right: 0;
  overflow: unset;
  scroll-snap-align: center;
  height: 100%;
`;

const overlayStyles = css`
  height: 100% !important;
  width: 104px;
  min-height: 110px !important;

  @media (min-width: 768px) {
    width: ${OVERLAY_WIDTH_EVOLUTION};
  }
`;

const errorStyles = css`
  background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
  background-image: none;

  img {
    display: none;
  }
`;

export const GalleryItemStyled = styled.div<{
  isLast?: boolean;
  hotelId: number | undefined;
  imagesCount: number;
  isOverlay: boolean;
  hasError: boolean;
  fullWidthOnMobile?: boolean;
  evolutionResultsOnlyEnabled?: boolean;
}>`
  background-color: ${({ theme }) => theme.kallisto.color.common.white['1000']};
  align-items: center;
  position: relative;
  overflow: hidden;
  scroll-snap-stop: always;
  scroll-snap-align: start;
  flex: none;
  display: flex;
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['300']};
  font-style: normal;
  margin-right: 3px;
  height: 200px;
  width: 230px;
  min-height: 200px;
  ${loadingBackground};
  ${userSelectNone};
  ${imageWidthStyle};
  ${imageRoundingStyles};

  ${({ isLast }) =>
    isLast &&
    css`
      margin-right: 0;
    `}
  ${({ imagesCount, isOverlay }) =>
    imagesCount === 1 &&
    !isOverlay &&
    css`
      width: 100%;
    `};
  ${({ imagesCount }) =>
    imagesCount === 1 &&
    css`
      margin-right: 0;
    `};

  @media (max-width: 767px) {
    ${mobileStyles};
    ${({ fullWidthOnMobile }) =>
      fullWidthOnMobile &&
      css`
        width: 100%;
      `};
    ${({ isOverlay, fullWidthOnMobile }) => !isOverlay && fullWidthOnMobile && mobileNonOverlayStyles};
  }
  @media (min-width: 768px) {
    ${desktopStyles}
  }

  ${({ isOverlay }) => isOverlay && overlayStyles};
  ${({ hasError }) => hasError && errorStyles};

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    object-fit: cover;
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    width: 100%;
  }
`;

export const ShowMore = styled.div<{ isOverlay?: boolean }>`
  text-decoration: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
  ${imageRoundingStyles};
  cursor: pointer;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.semibold};
  font-size: ${({ theme }) => theme.kallisto.font.size['200']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['200']};
  color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
  align-items: center;
  justify-content: center;
  ${userSelectNone};
`;
